import React from "react";
import DatePicker from "react-datepicker";

const CustomDatePicker = ({
    selected,
    onChange,
    dateFormat,
    maxDate,
    minDate,
    placeholderText,
    className,
    renderCustomHeader,
    showTimeSelectOnly,
    showTimeSelect,
    timeFormat,
    timeIntervals,
    timeCaption,
    showYearDropdown,
    showMonthDropdown,
    scrollableYearDropdown,
    useShortMonthInDropdown,
    minYear,
    maxYear,
    disabled
}) => {
    return (
        <DatePicker
            selected={selected}
            onChange={onChange}
            dateFormat={dateFormat}
            maxDate={maxDate}
            minDate={minDate}
            placeholderText={placeholderText}
            className={className}
            renderCustomHeader={renderCustomHeader}
            showTimeSelect={showTimeSelect}
            showTimeSelectOnly={showTimeSelectOnly}
            timeFormat={timeFormat || "HH:mm"}
            timeIntervals={timeIntervals || 15}
            timeCaption={timeCaption || "Time"}
            showYearDropdown={showYearDropdown}
            scrollableYearDropdown={scrollableYearDropdown}
            useShortMonthInDropdown={useShortMonthInDropdown}
            showMonthDropdown={showMonthDropdown}
            disabled={disabled}
        />
    );
};

export default CustomDatePicker;
